<template>
    <b-container  fluid class="event-tabs">
      <b-row  no-gutters >
        <b-col><router-link :to="{name: 'BookedEvents'}" key="MobileBookedEvents" exact>Booked Events</router-link></b-col>
        <b-col><router-link :to="{name: 'UpcomingEvents'}" key="MobileUpcomingEvents" exact>Upcoming Events</router-link></b-col>
        <b-col><router-link :to="{ name: 'CCUpdates'}" key="CCUpdates" exact>CC Updates</router-link></b-col>
      </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'EventTabs',
  data() {
    return {
    };
  },
};

</script>
<style scoped>
.event-tabs{
    background-color: #ebebeb;
    padding-top: 5px;
    padding-bottom: 10px;
    position: fixed;
    top: calc(8vh + 84px);
    z-index: 1;
}

a {
  text-decoration: none;
  padding: 5px 9px 5px 7px;
  background-color: #f3f3f3;
  font-family: Arial;
  font-size: 10px;
  line-height: 1.1;
  text-align: left;
  color: #7f7f7f;
  border-radius: 0 10px 10px 10px;
}
.router-link-exact-active,
.router-link-active {
  background-color: #bd9d5f !important;
  color: #fff !important;
}
</style>
